//#region src/utils/commonModels/customerAddress.ts
var e = {
	BILLING: "BILLING",
	SHIPPING: "SHIPPING"
}, t = (t) => t?.find(({ purposes: t }) => t.includes(e.BILLING))?.address ?? null, n = (t) => t?.find(({ purposes: t }) => t.includes(e.SHIPPING))?.address ?? null, r = (t) => !!t?.some(({ purposes: t }) => t.includes(e.BILLING) && t.includes(e.SHIPPING)), i = (t) => t ? [{
	purposes: [e.BILLING],
	address: t
}] : [], a = ({ billingAddress: t, shippingAddress: n, isShippingSameAsBilling: r }) => r ? t ? [{
	purposes: [e.BILLING, e.SHIPPING],
	address: t
}] : [] : [...i(t), ...n ? [{
	purposes: [e.SHIPPING],
	address: n
}] : []];
//#endregion
export { e as CUSTOMER_ADDRESS_PURPOSES, t as getBillingAddress, n as getShippingAddress, r as isShippingSameAsBilling, i as toBillingOnlyAddresses, a as toCustomerAddresses };

//# sourceMappingURL=index.js.map